import AccountManages from './accountManages'
import agAccountManages from './agAccountManages'
import SalesManages from './salesManages'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...AccountManages,
      ...agAccountManages,
      ...SalesManages
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/accountManage/index.js